import * as React from 'react';
import { StandardPageLayout } from '../common/StandardPageLayout';
import { Segment, Container, Loader, Dimmer, Image } from 'semantic-ui-react';

const LoadingPageLayout = () =>
  <StandardPageLayout id="loading" activeMenu="loading">

    <Segment vertical style={{ fontSize: '1.33em' }}>
      <Container>

        <Dimmer active inverted>
          <Loader />
        </Dimmer>

        <Image style={{ marginBottom: 20, marginTop: 20 }} src="/images/wireframe/media-paragraph.png" />
        <Image src="/images/wireframe/paragraph.png" />

      </Container>
    </Segment>

  </StandardPageLayout>

export default LoadingPageLayout



// WEBPACK FOOTER //
// ./src/loading/LoadingPageLayout.tsx